export const GAME_PACK = {
  starterTop: {
    labelKey: "GamePack_Top Games",
    filter: "starter_top_games",
  },
  starterEditor: {
    labelKey: "GamePack_Editor Picks",
    filter: "starter_editor_picks",
  },
  starterBest: {
    labelKey: "GamePack_Best Selling",
    filter: "starter_best_selling",
  },
  starterAll: {
    labelKey: "GamePack_All Games",
    filter: "Starter",
  },
  ultimateTop: {
    labelKey: "GamePack_Top Games",
    filter: "ultimate_top_games",
  },
  ultimateEditor: {
    labelKey: "GamePack_Editor Picks",
    filter: "ultimate_editor_picks",
  },
  ultimateBest: {
    labelKey: "GamePack_Best Selling",
    filter: "ultimate_best_selling",
  },
  ultimateAll: {
    labelKey: "GamePack_All Games",
    filter: "BLACKNUT",
  },
  byogTop: {
    labelKey: "GamePack_Top Games",
    filter: "byog_top_games",
  },
  byogEditor: {
    labelKey: "GamePack_Editor Picks",
    filter: "byog_editor_picks",
  },
  byogBest: {
    labelKey: "GamePack_Best Selling",
    filter: "byog_best_selling",
  },
  byogDemo: {
    labelKey: "GamePack_Demo Games",
    filter: "byog_demo",
  },
  byogAll: {
    labelKey: "GamePack_All Games",
    filter: "BYOG",
  },
  PID: {
    labelKey: "GamePack_All Games",
    filter: "PID",
  },
};

export const GAME_CARD_RATIO = 427 / 320;

export const VIDEO_CARD_RATIO = 270 / 480;

export const STEAM_LOGIN_PAGE = "https://store.steampowered.com/join";

export const LIBRARY_GAME_SIZE = 10;
